;(function() {
  "use strict"

  angular
    .module("UP")
    .directive("uniInfo", [
      "$timeout",
      "$log",
      function($timeout, $log) {
        return {
          restrict: "AE",
          scope: {
            title: "@",
            info: "@"
          },
          template:
            '<span>{{title}}</span> <span class="info-link">' +
            ' <a href="javascript:void(0)" ng-show="!plusinfo" ng-click="plusinfo = true"> + info </a> ' +
            ' <a href="javascript:void(0)" ng-show="plusinfo" ng-click="plusinfo = false"> - info </a> ' +
            '</span> <p ng-show="plusinfo">{{info}}</p>',
          link: function(scope, element, attrs) {
            $log.log("uniInfo 1")

            scope.plusinfo = false
          }
        }
      }
    ])
    .directive("uniInfo2", [
      "$timeout",
      "$log",
      function($timeout, $log) {
        return {
          restrict: "AE",
          scope: {
            title: "@",
            info: "@"
          },
          template:
            '<span ng-show="!plusinfo">{{title}}</span> <span ng-show="plusinfo">{{info}}</span> <span class="info-link">[' +
            '<a href="javascript:void(0)" ng-show="!plusinfo" ng-click="plusinfo = true" title="Mostrar más info">+ info</a>' +
            '<a href="javascript:void(0)" ng-show="plusinfo" ng-click="plusinfo = false" title="Mostrar menos info">- info</a>' +
            "]</span> ",
          link: function(scope, element, attrs) {
            $log.log("uniInfo 2")

            scope.plusinfo = false
          }
        }
      }
    ])
    .directive("uniInfo3", [
      "$timeout",
      "$log",
      function($timeout, $log) {
        return {
          restrict: "AE",
          scope: {
            title: "@",
            title2: "@",
            info: "@",
            linktext: "@",
            template: "@"
          },
          template:
            '<span title="{{title2}}">{{title}}</span> <span class="info-link">[' +
            '<a href="javascript:void(0)" ng-click="open()" title="Mostrar más info">{{linktext}}</a>]</span> ' +
            '<div class="fullscreen title="Pulsa para cerrar" ng-if="plusinfo" ng-click="cerrar ()">' +
            '<div class="fullscreen-bg"></div>' +
            '<div class="fullscreen-inner" > ' +
            '  <div class="fullcontent">' +
            '    <div ng-include="template"></div>' +
            "  </div>" +
            "</div>" +
            '  <div class="full-footer " ng-click="cerrar ()"><span class="info-block">Pulsa en la ayuda para cerrar</span></div>' +
            "</div>",
          link: function(scope, element, attrs) {
            $log.log("uniInfo 3")

            element.attr("title", "Pulsa para cerrar")

            if (!scope.linktext) scope.linktext = "+ info"

            scope.plusinfo = false

            scope.open = function() {
              scope.plusinfo = true

              $("body").addClass("modal-open")
            }
            scope.cerrar = function() {
              $log.log("cerrar uniInfo 3")
              scope.plusinfo = false

              $("body").removeClass("modal-open")
            }
          }
        }
      }
    ])
})()
